import React, { useContext } from 'react';
import { CartContext } from 'components/cart';
import PropTypes from 'prop-types';
import classNames from 'lib/classNames';

const EmptyState = () => {
	const { 
		Utils,
		cart_settings :{
			empty_cart,
			active_continue_shopping_button,
			active_continue_shopping_underlined,
			continue_shopping_button
		}
	 } = useContext(CartContext);
	return (
		<div id="mu-empty-cart" className={classNames('relative p-3 empty-cart w-full min-w-full max-w-full')}>
			<div dangerouslySetInnerHTML={{ __html: empty_cart }}></div>
			{
				active_continue_shopping_button && (
					<div
                		id="mu-continue-shopping"
						onClick={() => {
							if (window.mu_continue_shopping_logic) {
							const continueExecuting =
								window.mu_continue_shopping_logic();
							if (continueExecuting === false) return;
							}
							if (window.closeCart) window.closeCart();
						}}
						className={classNames(
							"custom-btn w-full w-full py-2 mb-2 text-center cursor-pointer"
						)}
						style={{
							color: Utils.formatColor(
							continue_shopping_button.color
							),
							fontSize: `${continue_shopping_button.font_size}em`,
							fontWeight: `${continue_shopping_button.font_weight}`,
							textDecoration:
							active_continue_shopping_underlined && "underline"
						}}
					>
						{continue_shopping_button.text}
					</div>
      			)
			}
		</div>
	);
};

EmptyState.propTypes = {};

export default EmptyState;
